import React, { useRef, useCallback } from "react";
import Webcam from "react-webcam";
import { createTheme, ThemeProvider, Button } from "@mui/material";
import maskImage from "../images/guid.png";

type Props = {
  handleCaptureImage: (imageSrc: string, capturing: boolean) => void;
};
const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#007bff",
          color: "#fff",
          fontSize: "1.0rem",
          "@media ( max-width: 752px )":{
            minWidth: "50vw",
          },
          "@media ( min-width: 753px )":{
            minWidth: "30vw",
          },
          marginTop: "2rem",
          "&:hover": {
            backgroundColor: "#0056b3",
          },
        },
      },
    },
  },
});
const WebCameraInput = (props: Props) => {
  const apsSize = window.innerWidth * 0.7;
  const absWidth = useRef(apsSize);
  const absHeight = useRef(apsSize / 0.75);
  const webcamRef = useRef<Webcam>(null);
  const capture = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    props.handleCaptureImage(imageSrc || "", false);
  };

  const videoConstraints = {
    facingMode: "user",
  };

  const handleOrientationChange = useCallback(() => {
    const isPortrait = window.innerHeight > window.innerWidth;

    if (isPortrait) {
      absWidth.current = window.innerWidth * 0.7;
      absHeight.current = absWidth.current / 0.75;
    } else {
      absWidth.current = window.innerWidth * 0.7;
      absHeight.current = absWidth.current / 0.75;
    }
  }, []);

  React.useEffect(() => {
    window.addEventListener("orientationchange", handleOrientationChange);
    // 向きの初期化
    handleOrientationChange();
    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, [handleOrientationChange]);

  return (
    <div>
      <>
        <h4
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
            fontSize: "1rem",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          ガイドラインに合わせて
          <br />
          撮影してください
        </h4>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={maskImage}
            alt="guid"
            style={{
              position: "absolute",
              width: apsSize,
              height: apsSize,
              pointerEvents: "none",
            }}
          />
          <Webcam
            audio={false}
            width={absWidth.current}
            height={absHeight.current}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ThemeProvider theme={theme}>
            <Button onClick={capture}>撮影</Button>
          </ThemeProvider>
        </div>
      </>
    </div>
  );
};
export default WebCameraInput;
